import React from 'react';
import { Route, Routes } from 'react-router-dom';
import GensDeMer from '../gensdemer/Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/gensdemer/home" element={<GensDeMer />} />
    </Routes>
  );
}

export default Router;
